export const BASE_URL = process.env.REACT_APP_KNNECT_BACKEND_BASE_URL;
export const WEB_SOCKET = process.env.REACT_APP_KNNECT_BACKEND_WEBSOCKET_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const AVATAR_SDK_KEY = process.env.REACT_APP_AVATAR_SDK_KEY;
export const AVATAR_SDK_SCRIPT = process.env.REACT_APP_AVATAR_SDK_SCRIPT;
export const AI_BASE_URL = process.env.REACT_APP_AI_BACKEND_URL;
export const KNNECT_DEMO_VIDEO_URL = process.env.REACT_APP_DEMO_VIDEO_URL;
